module.exports = __webpack_public_path__ + "static/media/background_mini.d1857a07.jpg";